import { useCallback, useState } from 'react'
import { Trophy, Swords, Clock } from 'lucide-react'
import AdminScreenShell, { Tegel, StatusRij } from '@/components/AdminScreenShell'
import { adminAPI } from '@/lib/api'

export default function AdminTornooienScreen() {
  const [d, setD] = useState(null)
  const load = useCallback(async () => {
    const r = await adminAPI.schermTornooien(); setD(r.data)
  }, [])
  const actief = d?.actief ?? []
  const matches = d?.wachtendeMatches ?? []
  const wachtOpRes = d?.wachtOpResult ?? []

  return (
    <AdminScreenShell title="Tornooien" subtitle="Live-tornooien + wachtende matches"
                      icon={Trophy} refreshMs={15_000} onRefresh={load}>
      <div className="grid grid-cols-4 gap-3 mb-4">
        <Tegel label="Actief"      waarde={actief.length} kleur="#B4FF39" groot />
        <Tegel label="In progress" waarde={wachtOpRes.length}
               sub="wacht op result" kleur={wachtOpRes.length > 0 ? '#FFB57A' : '#61E294'} />
        <Tegel label="Volgende"    waarde={matches.length - wachtOpRes.length}
               sub="klaar om te starten" kleur="#61E294" />
        <Tegel label="Deelnemers totaal"
               waarde={actief.reduce((n, t) => n + (t.spelers ?? 0), 0)}
               kleur="#B4FF39" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <Swords className="h-3 w-3 inline mr-1" /> Actieve tornooien
          </h2>
          {actief.length === 0 ? (
            <div className="text-muted-foreground text-sm">Geen tornooi loopt op dit moment.</div>
          ) : actief.map(t => (
            <StatusRij key={t.id}
              naam={t.name}
              sub={`${t.game ?? ''} · ${t.format ?? ''} · ronde ${t.current_round ?? '?'}/${t.total_rounds ?? '?'} · ${t.spelers} spelers`}
              status={t.status}
              kleur={/running|ongoing|in_progress/.test(t.status) ? '#61E294'
                    : /ready/.test(t.status) ? '#B4FF39' : '#FFB57A'} />
          ))}
        </div>

        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <Clock className="h-3 w-3 inline mr-1" /> Wachtende matches
          </h2>
          {matches.length === 0 ? (
            <div className="text-muted-foreground text-sm">Geen open matches.</div>
          ) : matches.map(m => (
            <StatusRij key={m.id}
              naam={`${m.p1 ?? '?'}  vs  ${m.p2 ?? '?'}`}
              sub={`${m.tournament} · ronde ${m.round}`}
              status={m.status}
              kleur={m.status === 'in_progress' ? '#FFB57A' : '#B4FF39'} />
          ))}
        </div>
      </div>
    </AdminScreenShell>
  )
}
